// extracted by mini-css-extract-plugin
export default {"content":"AccountSettings_content__s18Hy","subContent":"AccountSettings_subContent__PuERQ"};